// client/src/lib/pageAnalyticsProps.ts
//
// Page-level analytics properties, declared by the page and read at capture
// time. page_view is fired by AnalyticsTracker in the root layout, which knows
// only the pathname; facts that belong to the page's data (a /compare/ pair's
// audience, say) are not available there without shipping every page's data to
// every visitor. So the page server-renders a hidden marker:
//
//   <div hidden data-page-analytics='{"audience":"us_consumer"}' />
//
// and page_view, $pageview and cta_clicked merge whatever it holds. Pages
// without a marker send exactly what they sent before.

export const PAGE_ANALYTICS_ATTR = 'data-page-analytics';

export type PageAnalyticsProps = Record<string, string>;

/** Properties declared by the current page, or {} on the server / with no marker. */
export function getPageAnalyticsProps(): PageAnalyticsProps {
  if (typeof document === 'undefined') return {};
  const merged: PageAnalyticsProps = {};
  document.querySelectorAll(`[${PAGE_ANALYTICS_ATTR}]`).forEach(el => {
    try {
      const parsed: unknown = JSON.parse(el.getAttribute(PAGE_ANALYTICS_ATTR) ?? '{}');
      if (parsed && typeof parsed === 'object') {
        for (const [key, value] of Object.entries(parsed as Record<string, unknown>)) {
          if (typeof value === 'string') merged[key] = value;
        }
      }
    } catch {
      // A malformed marker must never break analytics; ignore it.
    }
  });
  return merged;
}
